import { spotlight_mobile } from "@/generated";
import { SpotlightService } from "@/generated/services/SpotlightService";
import { useQuery } from "@tanstack/react-query";

export function useFetchSpotlight(
  memberId: number,
  retailerId?: number,
  storeId?: number,
) {
  return useQuery({
    queryKey: ["spotlight", memberId, retailerId, storeId],
    enabled: !!memberId, // only run when memberId is valid
    queryFn: async (): Promise<spotlight_mobile[]> => {
      if (!memberId) throw new Error("Invalid member ID");

      const response = await SpotlightService.getSpotlightsMobile(
        Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0,
        memberId,
      );

      return response as spotlight_mobile[];
    },
    gcTime: 0, // Don't cache spotlight after unmount
    staleTime: 0, // Always treat spotlight as stale
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
    refetchOnReconnect: false,
  });
}
